<template>
  <div>
      <div dir="rtl" class="is-flex is-align-items-center is-justify-content-center">
        <div>
          <div class="is-flex is-justify-content-center">
            <div>
              <checkbox v-model="is_search_positions_by_company">Get positions by company name</checkbox>
              <div class="is-flex is-align-items-center is-justify-content-space-between">
                <a @click="searchPosition" class="button is-info" :class="{ 'is-loading': is_loading_results }">Search</a>
                <div class="horizontal_space"></div>
                <input dir="rtl" class="outlined full_width" v-model="search_term" placeholder="חפש/י משרה להוסיף">
              </div>
            </div>
          </div>
          <div v-if="position_search_results.length > 0" class="is-flex is-justify-content-center" style="margin-top: 10px;">
            <a @click="position_search_results = []" class="button is-danger">סגור</a>
          </div>
          <div v-if="position_search_results.length > 0" dir="rtl" class="position_search_results"
              :class="{ is_adding_position: is_adding_position }">
            <search-modal-positions @input="addPosition($event)" :results="position_search_results" :show_follow_button="true"></search-modal-positions>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Checkbox from '@/components/Checkbox'
import SearchModalPositions from '@/components/SearchModalPositions'
export default {
  name: 'related-position-adder',
  props: {
    payload: {
      type: Object,
      default: () => {}
    },
    filter_related_resources: {
      type: Array,
      default: () => undefined
    },
    pick_with_server_call: {
      default: true
    },
    pick_and_close: {
      default: true
    },
    search_by_action_type: {
      type: String,
      default: 'leader'
    },
    statuses: {
      type: String,
      default: 'active,editing'
    }
  },
  data () {
    return {
      is_loading_results: false,
      is_adding_position: false,
      is_search_positions_by_company: false,
      search_term: '',
      position_search_results: []
    }
  },
  watch: {
    filter_related_resources () {
      this.setPositionsSearchResults(this.position_search_results)
    }
  },
  methods: {
    searchPositionsByCompanyName (search_term) {
      this.is_loading_results = true
      this.$network_utils.caller.request('get', '/companies/', 'admin_headers', { name: search_term }).then(response => {
        this.$network_utils.getCompanyPositions({ current_company_id: response[0].id }).then(response => {
          this.setPositionsSearchResults(response)
        })
      }).catch(() => {
        this.setPositionsSearchResults([])
      })
    },
    searchPosition () {
      if (this.is_search_positions_by_company) {
        this.searchPositionsByCompanyName(this.search_term)
        return
      }
      this.setPositionsSearchResults([])
      let id = this.$utils.isNumeric(this.search_term) ? this.search_term : ''
      this.is_loading_results = true
      this.$network_utils.caller.request('get', '/positions/' + id, 'admin_headers', { position_title: this.search_term, statuses: this.statuses, sort: 'status' })
        .then(response => {
          this.setPositionsSearchResults(response)
        })
    },
    setPositionsSearchResults (results) {
      const data = Array.isArray(results) ? this.getFilteredSearchResults(results) : [results]
      this.position_search_results = data.sort((a, b) => {
        return b.is_hot - a.is_hot
      })
      this.is_loading_results = false
    },
    getFilteredSearchResults (results) {
      if (this.filter_related_resources == undefined) {
        return results
      }
      let related_positions_ids = this.filter_related_resources.map(related_resource => {
        return related_resource[this.search_by_action_type].position.id
      })
      return results.filter(result => !related_positions_ids.includes(result.id))
    },
    addPosition (position_to_add) {
      if (!this.pick_with_server_call) {
        this.close()
        this.$emit('input', position_to_add)
        return
      }
      if (!confirm('להוסיף את המשרה - ' + position_to_add.title + ' מחברה - ' + position_to_add.company.name + '?')) {
        return
      }
      this.is_adding_position = true
      this.$network_utils.createRelatedResource({
        leader_type: 'Position',
        leader_id: position_to_add.id,
        follower_type: 'Position',
        follower_id: this.payload.position_id
      }).then(response => {
        this.close()
        this.$emit('input', response)
      }).catch(() => {
        this.is_adding_position = false
        this.$utils.emit('show_toast', { text: 'ארעה שגיאה. סביר להניח שניסית להוסיף משרה שכבר מקושרת' })
      })
    },
    close () {
      if (!this.pick_and_close) {
        return
      }
      this.search_term = ''
      this.position_search_results = []
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    Checkbox,
    SearchModalPositions
  }
}
</script>
<style scoped>
  .position_search_results{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: #f2f2f2;
    margin-top: 10px;
    max-height: 510px;
    min-width: 600px;
    max-width: 600px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 10000000;
  }
</style>
